<mat-icon class="loading-animation">hourglass_empty</mat-icon>